export default "__VITE_ASSET__RrScDJ3n__"